/**
 * cardioTimeEstimator.js — Estimation du temps d'une séance Cardio. Plus simple que la
 * musculation (sessionTimeEstimator.js) : chaque bloc est DÉJÀ exprimé en secondes
 * (rounds × (effort + repos), ou temps limite pour l'AMRAP), pas besoin d'estimer une durée
 * d'exécution par répétition — juste sommer échauffement + blocs + retour au calme.
 */
export const estimateCardioSessionSeconds = (session) => {
  const warmup = session.warmup_seconds || 0;
  const cooldown = session.cooldown_seconds || 0;
  const blocks = (session.blocks || []).reduce((sum, b) => {
    if (b.method === 'amrap') return sum + (b.time_cap_seconds || b.work_seconds || 0);
    return sum + (b.rounds || 1) * ((b.work_seconds || 0) + (b.rest_seconds || 0));
  }, 0);
  return warmup + cooldown + blocks;
};

export const estimateCardioSessionMinutes = (session) => Math.round(estimateCardioSessionSeconds(session) / 60);
